import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxFileUploadComponent } from './mx.file-upload.component';

export const COMPONENTS: any[] = [
  MxFileUploadComponent,
];

@NgModule({
  imports: [CommonModule, PrimengModule, I18NextModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxFileUploadModule {}
